import { BaseState } from '@/store/base-state';
import { TableOptions, PaginationProps } from '@/types';
import { PartnerProducts } from '../types';
import { default_partner_product } from '../services';

export default class PartnerProductsState extends BaseState {
  partner_products: PartnerProducts.Item[] = [];

  new_partner_product: PartnerProducts.NewItem = {
    ...default_partner_product(),
  };

  loading = false;

  filters: PartnerProducts.RequestFilters = {
    search: '',
  }

  pagination: PaginationProps = {
    current_page: 1,
    total_pages: 1,
    total_items: 0,
    limit: 10,
  };

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['product_code'],
    sortDesc: [true],
  };
}
